// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { LMStatePersistenceService } from '@services/lm-state-persistence.service';

@Injectable()
export class LMPageStateService {
  constructor(private lmStatePersistenceService: LMStatePersistenceService) {}

  public getPageState(pageStateKeyParams: LMPageStateKeyParams): LMPageState {
    return this.lmStatePersistenceService.getState(pageStateKeyParams.getKey()) as LMPageState;
  }

  public savePageState(pageStateKeyParams: LMPageStateKeyParams, pageStateItem: LMPageState): void {
    this.lmStatePersistenceService.persistState(pageStateKeyParams.getKey(), pageStateItem);
  }

  public deletePageState(pageStateKeyParams: LMPageStateKeyParams): void {
    this.lmStatePersistenceService.removeState(pageStateKeyParams.getKey());
  }
}

export class LMPageStateKeyParams {
  lidKey?: string;
  actorId?: string;
  asOfDate?: string;
  dataArea: string;
  routeResourceId: string;
  pagePanelId?: string;

  private key = '';

  getKey() {
    if (!this.key) {
      this.buildKey();
    }
    return this.key;
  }

  private buildKey(): void {
    const stringArray = new Array<string>();

    if (this.lidKey) {
      stringArray.push(this.lidKey);
    }
    if (this.actorId) {
      stringArray.push(this.actorId);
    }
    if (this.asOfDate) {
      stringArray.push(this.asOfDate);
    }

    stringArray.push(this.dataArea);
    // page is only a top level component therefore do not need a resourceId
    stringArray.push(this.routeResourceId);
    if (this.pagePanelId) {
      stringArray.push(this.pagePanelId);
    }

    this.key = stringArray.join('_');
  }
}
